import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import Animation from '../../Animation';
import Select from '../../engine/SelectEngine';
import { ConditionsQueryBuilderContext } from '../engine/ConditionsQueryBuilderEngine';
import { AddRemoveBtns, ConditionRow } from './FieldsQueryBuilderView';
const Container = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: column;

  & > div {
    width: 100%;
  }
`;
const StatusQueryBuilderView = props => {
  const { variant } = useContext(ConditionsQueryBuilderContext);

  return (
    <Container>
      {Object.entries(props.statuses).map(([id, status], i) => (
        <Animation
          type="collapse"
          in={props.inDeleteSequence !== id}
          key={id}
          onExited={() => props.removeCondition(id)}
        >
          <ConditionRow $marked={props.hoverOn === id}>
            <span
              style={{
                marginRight:
                  i === 0 && Object.entries(props.statuses).length > 1
                    ? '2.1rem'
                    : undefined
              }}
            >{`${i === 0 ? '' : 'or'} ${props.sentencePrefix}`}</span>
            <Select
              value={status}
              onChange={value => props.setStatus(id, value)}
              placeholder="Select status..."
              data-testid="condition-builder-status-select"
              options={props.options}
              variant={variant}
            />
            <AddRemoveBtns
              id={id}
              setHoverOn={props.setHoverOn}
              onRemove={props.onRemoveConditionClicked}
              addCondition={props.addCondition}
            />
          </ConditionRow>
        </Animation>
      ))}
    </Container>
  );
};

export default StatusQueryBuilderView;
